import { Braces, Database, FlaskConical, Globe, Network, Server, Sparkles, Wrench } from "lucide-react";
import Reveal from "@/components/ui/Reveal";
import { SKILLS } from "@/data/portfolio";

const ICONS = { Braces, Server, Network, Database, Globe, Sparkles, FlaskConical, Wrench };

export default function SkillsWindow() {
  return (
    <div className="space-y-5 p-6 sm:p-7" data-testid="skills-content">
      <div className="flex items-baseline justify-between gap-3">
        <p className="eyebrow">tree skills/ --depth=∞</p>
        <p className="font-mono text-[10px] text-slate-500">{SKILLS.length} groups · {SKILLS.reduce((n, g) => n + g.items.length, 0)} entries</p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-testid="skills-grid">
        {SKILLS.map((g, i) => {
          const Icon = ICONS[g.icon] || Braces;
          return (
            <Reveal key={g.group} delay={i * 0.05} className="h-full">
              <div className="group h-full rounded-xl border border-white/8 bg-white/[.03] p-4 transition-colors duration-200 hover:border-sonoma/30 hover:bg-white/[.05]">
                <div className="mb-3 flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-sonoma/15 ring-1 ring-sonoma/25 transition-transform duration-200 group-hover:scale-105">
                    <Icon size={14} className="text-sky-300" />
                  </span>
                  <p className="font-mono text-xs font-medium text-slate-200">{g.group}</p>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {g.items.map((it) => (
                    <span key={it} className="rounded-md bg-white/[.06] px-2 py-1 font-mono text-[10.5px] text-slate-300 transition-colors duration-150 hover:bg-sonoma/20 hover:text-sky-200">
                      {it}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  );
}
